import * as angular from 'angular';

export class BaseSideBarWidget {
	public visible = true;
	public order = 1;
	public content = 'DEFAULT WIDGET TEMPLATE';

	constructor(options: { order?: number; content?: string } = {}) {
		this.order = options.order || this.order;
		this.content = options.content || this.content;
	}
}

export class SideBarWidgetsFactory {
	public createNavigationWidget(order?: number) {
		return new BaseSideBarWidget({
			order,
			content: '<mx-widget-navigation></mx-widget-navigation>',
		});
	}
}

angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.SideBarWidgetsFactory', SideBarWidgetsFactory);
